import { getAmericanTime } from '@helpers/getAmericanTimezone';
import type { GetOrgMembersMemberResponseDto } from 'app/API';

export const MEMBERS_CSV_HEADERS = ['ID', 'Name', 'Email', 'Phone', 'Enabled', 'Teams', 'Cloud Layouts', 'Created'];

export type TMemberCsvSource = Pick<
  GetOrgMembersMemberResponseDto,
  'id' | 'name' | 'lastname' | 'email' | 'phone' | 'disabledInOrg' | 'canManageLayouts' | 'createdAt'
> & {
  teams: Array<{ name: string; organizationId: string }>;
};

export const buildMembersCsvRows = (members: TMemberCsvSource[], organizationId: string) =>
  members.map((member) => ({
    id: member.id,
    name: `${member.name} ${member.lastname}`,
    email: member.email,
    phone: member.phone,
    enabled: member.disabledInOrg ? 'No' : 'Yes',
    teams: member.teams
      .filter((team) => team.organizationId === organizationId)
      .map((team) => team.name)
      .join(' '),
    cloudLayouts: member.canManageLayouts ? 'Yes' : 'No',
    created: getAmericanTime(member.createdAt),
  }));
